import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../config/api';
import SuperAdminLayout from '../components/SuperAdminLayout';

const SuperAdminDashboard = () => {
  const [tenants, setTenants] = useState([]);
  const [sites, setSites] = useState([]);
  const [systemAnalytics, setSystemAnalytics] = useState({});

  
  const [newTenant, setNewTenant] = useState({
    name: '', subdomain: '', email: '', phone: ''
  });

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      fetchTenants();
      fetchSites();
      fetchSystemAnalytics();
    }
  }, []);

  const fetchTenants = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_BASE_URL}/api/tenants`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setTenants(response.data.tenants || []);
    } catch (error) {
      console.error('Error fetching tenants:', error);
      setTenants([]);
    }
  };

  const fetchSites = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_BASE_URL}/api/sites`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSites(response.data.sites || []);
    } catch (error) {
      console.error('Error fetching sites:', error);
      setSites([]);
    }
  };

  const fetchSystemAnalytics = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_BASE_URL}/api/super-admin/analytics`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSystemAnalytics(response.data.system || {});
    } catch (error) {
      console.error('Error fetching analytics:', error);
      setSystemAnalytics({});
    }
  };



  return (
    <SuperAdminLayout>
      <header style={{
        background: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 50%, #10b981 100%)',
        color: 'white',
        padding: '16px 20px',
        boxShadow: '0 4px 15px rgba(6, 182, 212, 0.2)'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h1 style={{ fontSize: '1.5rem', fontWeight: '700', margin: '0 0 4px 0' }}>Super Admin Dashboard</h1>
            <p style={{ color: 'rgba(255,255,255,0.8)', margin: 0, fontSize: '0.85rem' }}>System overview</p>
          </div>
          <div style={{
            background: 'rgba(255,255,255,0.2)',
            padding: '6px 12px',
            borderRadius: '8px',
            fontSize: '0.8rem',
            fontWeight: '600'
          }}>
            {tenants.length} Tenants
          </div>
        </div>
      </header>

      <main style={{ padding: '16px', overflow: 'auto' }}>
        <div style={{ display: 'grid', gap: '16px' }}>
          {/* Compact Stats */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
            gap: '12px'
          }}>
            {[
              { title: 'Tenants', value: tenants.length, icon: '🏢', color: '#06b6d4' },
              { title: 'Sites', value: sites.filter(s => s.isActive !== false).length, icon: '🏛️', color: '#10b981' },
              { title: 'Revenue', value: `₹${(systemAnalytics.totalRevenue || 0).toLocaleString()}`, icon: '💰', color: '#0891b2' },
              { title: 'Bookings', value: (systemAnalytics.totalBookings || 0).toLocaleString(), icon: '📊', color: '#14b8a6' }
            ].map((stat, index) => (
              <div key={index} style={{
                background: 'white',
                borderRadius: '12px',
                padding: '16px',
                boxShadow: '0 4px 15px rgba(6, 182, 212, 0.1)',
                border: '1px solid rgba(6, 182, 212, 0.1)',
                display: 'flex',
                alignItems: 'center',
                gap: '12px'
              }}>
                <div style={{
                  width: '40px',
                  height: '40px',
                  background: stat.color,
                  borderRadius: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '1.2rem'
                }}>
                  {stat.icon}
                </div>
                <div>
                  <div style={{ fontSize: '0.75rem', color: '#64748b', fontWeight: '600', textTransform: 'uppercase' }}>{stat.title}</div>
                  <div style={{ fontSize: '1.3rem', fontWeight: '700', color: '#1e293b', marginTop: '2px' }}>{stat.value}</div>
                </div>
              </div>
            ))}
          </div>

          {/* Compact Content Grid */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: window.innerWidth <= 768 ? '1fr' : '2fr 1fr',
            gap: '16px'
          }}>
            {/* Recent Tenants */}
            <div style={{
              background: 'white',
              borderRadius: '12px',
              padding: '16px',
              boxShadow: '0 4px 15px rgba(6, 182, 212, 0.1)',
              border: '1px solid rgba(6, 182, 212, 0.1)'
            }}>
              <h3 style={{ fontSize: '1.1rem', fontWeight: '700', color: '#1e293b', marginBottom: '12px' }}>Recent Tenants</h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {tenants.slice(0, 4).map(tenant => (
                  <div key={tenant._id} style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '10px',
                    background: '#f8fafc',
                    borderRadius: '8px'
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <div style={{
                        width: '28px',
                        height: '28px',
                        background: 'linear-gradient(135deg, #06b6d4, #10b981)',
                        borderRadius: '6px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '0.9rem'
                      }}>
                        🏢
                      </div>
                      <div>
                        <div style={{ fontWeight: '600', color: '#1e293b', fontSize: '0.85rem' }}>{tenant.name}</div>
                        <div style={{ fontSize: '0.7rem', color: '#64748b' }}>{tenant.subdomain}.tiketjini.com</div>
                      </div>
                    </div>
                    <span style={{
                      padding: '3px 6px',
                      borderRadius: '10px',
                      fontSize: '0.65rem',
                      fontWeight: '600',
                      background: tenant.isActive ? '#dcfce7' : '#fee2e2',
                      color: tenant.isActive ? '#166534' : '#991b1b'
                    }}>
                      {tenant.isActive ? '✅' : '❌'}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            {/* Quick Actions */}
            <div style={{
              background: 'white',
              borderRadius: '12px',
              padding: '16px',
              boxShadow: '0 4px 15px rgba(6, 182, 212, 0.1)',
              border: '1px solid rgba(6, 182, 212, 0.1)'
            }}>
              <h3 style={{ fontSize: '1.1rem', fontWeight: '700', color: '#1e293b', marginBottom: '12px' }}>Quick Actions</h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                {[
                  { to: '/super-admin/tenants', icon: '🏢', text: 'Manage Tenants', color: '#06b6d4' },
                  { to: '/super-admin/sites', icon: '🏛️', text: 'View Sites', color: '#10b981' },
                  { to: '/super-admin/analytics', icon: '📊', text: 'Analytics', color: '#0891b2' },
                  { to: '/super-admin/payment-gateways', icon: '💳', text: 'Payment Gateways', color: '#14b8a6' },
                  { to: '/super-admin/phonepe-tsp', icon: '📱', text: 'PhonePe TSP', color: '#9333ea' }
                ].map((action, index) => (
                  <Link key={index} to={action.to} style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    padding: '10px',
                    background: '#f8fafc',
                    borderRadius: '8px',
                    textDecoration: 'none',
                    color: '#1e293b',
                    transition: 'all 0.2s ease'
                  }}
                  onMouseOver={(e) => e.target.style.background = 'rgba(6, 182, 212, 0.05)'}
                  onMouseOut={(e) => e.target.style.background = '#f8fafc'}>
                    <div style={{
                      width: '28px',
                      height: '28px',
                      background: action.color,
                      borderRadius: '6px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '0.9rem'
                    }}>
                      {action.icon}
                    </div>
                    <span style={{ fontWeight: '600', fontSize: '0.85rem' }}>{action.text}</span>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </main>
    </SuperAdminLayout>
  );
};

export default SuperAdminDashboard;